<template>
  <div class="reports-add-jobs reports-add-jobs-workorder">
    <el-dialog
      append-to-body
      :visible.sync="dialogObject"
      @close="clear"
      title="Отчет по работе"
      custom-class="add-jobs-dialog-workorder">
      <div>
        <div>
          <div class="head-date">
            <div style="display: flex; align-items: center" :class="{'disable-report':  form.approve}">
              <el-date-picker
                :editable="false"
                format="yyyy-MM-dd"
                v-model="form.datetime"
                type="date"
                placeholder="Укажите дату"
              />
              <i style="pointer-events: none; margin-left: 8px" class="el-icon-success" v-if="form.approve"></i>
            </div>

            <div class="history">
              <div class="report-number">
                <span>Номер отчета</span>
                <strong v-if="form.reportId || form.id">
                  <router-link style="color: #000;" :to="`/dashboard/reports/create/${form.reportId || form.id}/JOB`">
                    #{{ form.reportIndex || form.index }}
                  </router-link>
                </strong>
                <strong v-else>#{{ form.index ? form.index : currentIndexReport }}</strong>
              </div>
              <i class="el-icon-time" v-if="form && editIndex !== 'create'" @click="dialogObjectSearch = true"></i>
            </div>
            <el-dialog title="Список отчетов" append-to-body :visible.sync="dialogObjectSearch">
              <SearchReports :isEditable="isEditable" :reports="reports || []" :mainForm="mainForm"
                             v-if="dialogObjectSearch" type="JOB"
                             :user="user"
                             :job-id="originalId" @select="selectJobInsert"/>
            </el-dialog>
          </div>
          <AddJobs :approve="approve" :isEditable="isEditable" :job="insertJob" @save="saveCopy" ref="addJobsInsert"/>

          <div>
            <div @click="copyJobOpen = true" style="margin-bottom: 8px; display: flex; align-items: center">
              <span><strong>{{ form.job.name || form.name }}</strong>{{
                  form.job.unit ? `, ${(form.job.unit && form.job.unit.label || form.job.unit)}` : ''
                }}</span>
              <i v-if="editIndex === 'create'" style="display: flex; margin-left: 8px"
                 class="el-icon-document-copy" @click="copyJobOpen = true"></i>
            </div>
            <el-input :class="{'disable-report':  form.approve}" :placeholder="'Значение'"
                      v-model="form.value" class="input-with-select">
              <template
                v-if="!isCreateCustom"
                slot="append">{{
                  form.job.is_unit_value ? 'шт' : (form.job.unit && form.job.unit.label || form.job.unit)
                }}
              </template>
            </el-input>

            <el-input :class="{'disable-report':  form.approve}" v-model="form.job.comment"
                      style="margin-top: 8px; margin-bottom: 8px" placeholder="Комментарий"
                      type="textarea" textarea/>
            <div class="add-jobs-values">
              <span style="margin-right: 8px">П: <strong>{{ toFixedWithoutZero(calcPlan || 0) }}</strong></span>
              <span style="margin-right: 8px">Ф: <strong>{{
                  toFixedWithoutZero(calcValue)
                }}</strong></span>
              <span style="margin-right: 8px">+\-: <strong>{{
                  (toFixedWithoutZero((calcValue) - (calcPlan || 0)))
                }}</strong></span>
              <strong v-if="Number(calcPlan)"
                      :style="{color: pStatus(findPercentage(calcValue, calcPlan))}">
                {{ findPercentage(calcValue, calcPlan) }}%
              </strong>
            </div>
          </div>
        </div>
        <div class="add-jobs" style="margin-bottom: 8px" :class="{'disable-report':  form.approve}">
          <div style="margin-top: 6px">
            <div v-for="input in form.job.inputs || []">
              <div v-if="input.type === 'text'" style="margin-top: 10px">
                <strong style="color: black">{{ input.name }}
                </strong>
                <el-input
                  style="margin-top: 4px"
                  :placeholder="input.name"
                  v-model="input.value"
                  type="number"

                  class="input-with-select"
                >
                </el-input>
              </div>
              <div v-if="input.type === 'number'" style="margin-top: 10px">
                <strong style="color: black">{{ input.name }}
                </strong>
                <el-input
                  :controls="false"
                  style="margin-top: 4px"
                  type="number"
                  :placeholder="input.name"
                  v-model="input.value"
                  class="input-with-select"
                />
              </div>
              <div v-if="input.type === 'date'" style="margin-top: 10px; display: flex; flex-direction: column">
                <strong style="color: black; margin-bottom: 8px">{{ input.name }}
                </strong>
                <el-date-picker
                  format="yyyy-MM-dd"
                  v-model="input.value"
                  type="date"
                  placeholder="Укажите дату"
                >
                </el-date-picker>
              </div>
              <div v-if="input.type === 'calc'" style="margin-top: 10px; display: flex; flex-direction: column">
                <strong style="color: black; margin-bottom: 8px">{{ input.name }}</strong>

                <el-input
                  :controls="false"
                  style="margin-top: 4px; max-width: 220px; pointer-events: none"
                  type="number"
                  :placeholder="input.name"
                  :value="getCalc(input)"
                  class="input-with-select"
                />
              </div>

              <div
                v-if="input.type.includes('materials') || input.type.includes('constructions') || input.type.includes('multiple')">
                <div class="material-title" style="margin-bottom: 8px; margin-top: 10px">
                  <strong style="color: black;">{{ input.name }}
                  </strong>
                  <span
                    v-if="showCalc(input.volumeId) && input.type.includes('multiple')"
                    @click="toFactMultiple(input)"
                    class="sum-icon" style="margin-left: 4px">&sum;</span>
                  <span
                    v-else
                    @click="toFact(input)"
                    class="sum-icon" style="margin-left: 4px">&sum;</span>
                </div>
                <filter-select
                  noTag
                  @blur="input.isLoading = false"
                  :isLoading="input.isLoading"
                  @search="(s) => searchWithoutDelay(s, input)"
                  @addNew="(name) => addNew(input, name)"
                  :addNewEnable="input.isEditable"
                  multiple
                  @select="(e) => inputMaterial(e, input)"
                  hide-label
                  @focus="searchWithoutDelay('', input)"
                  @remove="(e) => removeMaterial(e, input)"
                  v-model="input.value"
                  @input="inputOption(input)"
                  :label="input.name" :options="sortOptions(filterMaterials(input) || [], input.value, input)">
                </filter-select>
              </div>


              <div v-if="input.type === 'select' || input.type === 'zone'">
                <div class="material-title" style="margin-bottom: 8px; margin-top: 10px">
                  <strong style="color: black;">{{ input.name }}
                  </strong>
                  <span
                    v-if="showCalc(input.volumeId) && input.type.includes('multiple')"
                    @click="toFactMultiple(input)"
                    class="sum-icon" style="margin-left: 4px">&sum;</span>
                </div>
                <filter-select
                  noTag
                  @blur="input.isLoading = false"
                  @focus="searchWithoutDelay('', input)"
                  :isLoading="input.isLoading"
                  @addNew="(name) => addNew(input, name)"
                  :addNewEnable="input.isEditable"
                  :multiple="input.type.includes('multiple')"
                  @input="(opt) => inputOption(input, opt)"
                  hide-label
                  @search="(s) => searchWithoutDelay(s, input)"
                  v-model="input.value"
                  :label="input.name"
                  :options="sortOptions(input.type.includes('multiple') ? (filterMaterials(input) || []) : (input.options || []), input.value, input)">
                </filter-select>
              </div>

              <div v-if="input.type === 'population'" style="margin-bottom: 8px; margin-top: 10px;">
                <div style="color: black; display: flex">
                  {{ input.name }}
                  <add-prof-tech-to-job
                    v-if="!(user.role === 'admin' && user &&  user.usePermission)"
                    :mainForm="getCurrentObj()"
                    @save="saveProf" :table="form.PROF || []" :workTypeOptions="workTypeOptions" type="PROF"/>
                </div>
                <el-row style="margin-top: 8px">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input disabled  style="margin-right: 8px" :value="`${planFactProf.value || 0} кол-во`">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="available_reports && available_reports[`PROF_TIME`]">
                    <el-form-item>
                      <el-input  disabled style="margin-left: 8px"
                                :value="`${(planFactProf.total)} часы`"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>


              <template v-if="input.type === 'nomenclature'">

                <NomenclatureInput
                  :options_works="options_works"
                  :job="mainForm"
                  :dirs="dirs"
                  @toFact="toFactNomenclature" :selectValuesProp="input.selectValues" :nomenclature="input"
                  @save="(e) => saveNomennclature(e, input)"/>
              </template>

              <div v-if="input.type === 'tech'" style="    margin-bottom: 8px; margin-top: 10px;">
                <strong style="color: black">{{ input.name }} <i style="cursor: pointer" class="fa fa-chevron-right"
                                                                 @click="openAddTech"/></strong>
                <el-row style="margin-top: 8px">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input disabled style="margin-right: 8px" :value="`${techValue.fact || 0} кол-во`">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="available_reports && available_reports[`TECH_TIME`]">
                    <el-form-item>
                      <el-input disabled style="margin-left: 8px" :value="`${techValue.time || 0} часы`"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>

        <div :class="{'disable-report': form.approve}">
          <filter-select
            v-model="form.turn"
            label="Смена"
            :options="shifts"
          />

          <filter-select
            v-if="role === 'admin'"
            v-model="form.user"
            label="Исполнитель"
            :options="usersOptions"
          />
        </div>
      </div>

      <div class="report-file">
        <UploadFile
          :disabled="this.form.timesheetId || form.approve"
          :fileListProps="fileList"
          @add-file="addFile"
        />
        <div :key="index" v-for="(file, index) in form.files" class="links-list">
          <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
          <i class="el-icon-delete" :class="{'disable-report':  form.approve}" @click="deleteImg(index)"></i>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          @click="removeReportClick"
          style="margin-left: 0; padding: 12px 8px"
          v-if="openUid && (user && !user.usePermission) && !form.approve"
          type="danger"
        >Удалить
        </el-button>
        <el-button
          :loading="loader" :disabled="loader"
          v-if="!form.approve && (user && !user.usePermission)"
          style="margin-left: 0; padding: 12px 8px"
          @click="save"
          type="primary"
        >Сохранить
        </el-button>
        <el-button style="margin-left: 0; padding: 12px 8px" @click="clear">
          Закрыть
        </el-button>
      </div>
    </el-dialog>

    <AddNewOption :isEditable="isEditable" @close="" ref="addNewOption" @new-option="addNewInput"/>
    <el-dialog
      :show-close="false"
      :title="selectMaterial.label"
      :visible.sync="openDialogMaterials"
      width="30%"
      center
    >
      <div v-if="selectMaterial && selectMaterial.details">
        <template v-if="!selectMaterial.type.includes('multiple')">
          <el-input
            :controls="false"
            style="margin-top: 4px"
            type="number"
            @input="inputMat(selectMaterial)"
            placeholder="Значение"
            v-model="selectMaterial.fact"
            class="input-with-select">
            <template slot="append">{{ selectMaterial.details[1] && selectMaterial.details[1].label }}</template>
          </el-input>
          <div style="display: flex; align-items: center; margin-top: 8px">
            <span v-if="!selectMaterial.withoutPlan">План: <strong>{{ selectMaterial.details[2] || 0 }}</strong></span>
          </div>


          <template v-if="selectMaterial.type.includes('constructions')">
            <el-input
              :controls="false"
              style="margin-top: 22px"
              type="number"
              placeholder="Значение"
              v-model="selectMaterial.factUnit"
              class="input-with-select">
              <template slot="append">{{ selectMaterial.details[3] && selectMaterial.details[3].label }}</template>
            </el-input>
            <div style="display: flex; align-items: center; margin-top: 8px" v-if="!selectMaterial.withoutPlan">
              <span>План на ед: <strong>{{ selectMaterial.details[4] || 0 }}</strong></span>
            </div>
          </template>
        </template>

        <div v-if="selectMaterial.isDetail" style="margin-top: 22px">
          <el-input v-model="selectMaterial.detail" placeholder="Примечание"></el-input>
        </div>

        <div style="display: flex; align-items: center; margin-top: 12px"
             v-if="!selectMaterial.withoutPlan && !selectMaterial.type.includes('multiple')">
          <el-checkbox
            v-model="selectMaterial.inVolume"
            label="в объем"
          ></el-checkbox>
        </div>
      </div>

      <div style="margin-top: 32px; display: flex; justify-content: flex-end">

        <el-button :loading="loader" :disabled="loader" type="primary" @click="saveMaterial(true)">Сохранить</el-button>
        <el-button @click="closeMaterial">Закрыть</el-button>
      </div>
    </el-dialog>

    <el-dialog
      append-to-body
      title="Копировать отчет"
      :visible.sync="copyJobOpen"
      width="300px"
    >
      <div style="display: flex; flex: 1; margin-left: 20px; margin-bottom: 4px">
        <strong>Дата нового отчета</strong>
      </div>
      <el-date-picker
        :editable="false"
        format="yyyy-MM-dd"
        v-model="form.datetime"
        type="date"
        placeholder="Укажите дату"
      />
      <span slot="footer" class="center" style="display: flex; justify-content: center">
        <el-button @click="copyJobOpen = false">Отмена</el-button>
        <el-button type="primary" @click="doCopy">Копировать</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="addProffModal">

      <ListJobs
        isModal
        ref="listJob"
        :dirs="dirs"
        :originalForm="form"
        type="PROF"
        :props-form="childForm.PROF"
        :options_works="options_works"
      />
    </el-dialog>
  </div>
</template>

<script>
import JobsCreate from '../../Jobs/Create';
import MaterialsCreate from '../../Jobs/Materials';
import {BigNumber} from "bignumber.js";
import UnitSelect from '../../components/unitSelect';
import FilterSelect from "../../../../components/FilterSelect";
import AddNewOption from "../../Reports/components/AddNewOption";
import {v4 as uuidv4} from "uuid";
import _, {debounce, orderBy} from "lodash";
import {getUsersOptions} from "../../../../firestore/users";
import UploadFile from "../../Reports/components/UploadFile";
import firebase from "firebase";
import {getZonesOptions} from "../../../../firestore/inputs";
import AddProfTechToJob from "./AddProfTechToJob";
import dayjs from "dayjs";
import SearchReports from "./SearchReports";
import NomenclatureInput from "../../Reports/components/NomenclatureInput";
import CyrillicToTranslit from "cyrillic-to-translit-js";
import {fetchIndex} from "../../../../firestore/reports";
import {getJobStructure, getJobStructurePROF} from "../../../../utils/jobStructure";

import ListJobs from "../../Reports/components/ListJobs";
import {getRole} from "../../../../firestore/permission";
import {toFixedWithoutZero, toFloat} from "../../../../utils/numberUtils";
import job from "../../Analytics/Job";
import {getUnits} from "../../../../firestore/units";

function percentage(num, per) {
  return new BigNumber(num).dividedBy(100)
    .multipliedBy(per).toNumber()
}


export default {
  name: 'AddJobs',
  components: {
    ListJobs,
    NomenclatureInput,
    SearchReports,
    AddProfTechToJob, UploadFile, AddNewOption, FilterSelect, MaterialsCreate, JobsCreate, UnitSelect
  },
  props: ['job', 'index', 'workTypeOptions', 'mainForm', 'user', 'approve', 'options_works', 'isEditable', 'dirs'],
  data() {
    return {
      dialogObjectSearch: false,
      fileList: [],
      calcValue: 0,
      calcPlan: 0,
      addProffModal: false,
      formIndex: 0,
      copyJobOpen: false,
      role: '',
      structureObj: null,
      prevZone: null,
      dialogObject: false,
      loadingCopy: false,
      openDialogMaterials: false,
      openUid: null,
      currentIndexReport: null,
      isEdit: false,
      originalId: null,
      reports: [],
      usersOptions: [],
      input: {},
      editIndex: null,
      loader: false,
      shifts: [{
        label: 1,
        value: 1,
      }, {
        label: 2,
        value: 2,
      }, {
        label: 3,
        value: 3,
      }],
      editProf: {},
      isCreateCustom: null,
      zoneLock: false,
      reportPROFIndex: null,
      reportPROF: null,
      childForm: {
        PROF: {
          jobs: [[]],
          jobs_internal: [],
          work_type: [],
          work_type_dir: [],
          turn: {
            value: 1,
            label: 1,
          },
          daily_plan: {
            workers: '',
            itr: '',
          },
        },
        TECH: {
          jobs: [[]],
          jobs_internal: [],
          work_type: [],
          work_type_dir: [],
          turn: {
            value: 1,
            label: 1,
          },
          daily_plan: {
            workers: '',
            itr: '',
          },
        }
      },
      profValue: {
        time: 0,
        fact: 0
      },
      selectMaterial: {},
      techValue: {
        time: 0,
        fact: 0
      },
      insertJob: {},
      form: {
        user: null,
        turn: {
          label: 1,
          value: 1
        },
        comment: '',
        job: {},
        files: [],
        datetime: dayjs().format(),
        TECH: {},
        PROF: {},
      },
    };
  },

  async mounted() {
    this.role = await getRole(this.$store.state.project.id);

    this.available_reports = this.$store.state.project.available_reports;
    const users = await getUsersOptions(this.$store.state.project.id, true)
    this.usersOptions = users.filter((u) => u._data.isCompany)

  },
  computed: {
    planFactTech() {
      return {plan: this.form.TECH.plan, value: this.form.TECH.value, time: this.form.TECH.time}
    },
    planFactProf() {
      let total = 0

      if (this.form.PROF && this.form.PROF.jobs) {
        this.form.PROF.jobs.forEach((job) => {
          total +=  BigNumber( Number(job.time || 0)).multipliedBy(Number(job.value || 0)).toNumber();
        })
      }
      return {plan: this.form.PROF.plan, value: this.form.PROF.value, time: this.form.PROF.time, total}
    },
  },
  watch: {
    'form.job': {
      deep: true,
      async handler(job = {}) {
        if (!job) {
          return
        }

        const n = job && job.inputs || []

        const nextZone = n.find(({id}) => id === 'zone')
        if ((nextZone && nextZone.value && nextZone.value.value) !== (this.prevZone && this.prevZone.value && this.prevZone.value.value)) {
          let inputs = [...((this.form.job && this.form.job.inputs) || [])]

          inputs = inputs.map((input) => {
            if ((input.type.includes('materials') || input.type.includes('constructions') || input.type.includes('multiple')) && !this.zoneLock) {
              return {
                ...input,
                options: [...(input.options || [])].map((option) => {
                  if (!option.isZone && !option.zoneId) {
                    return option
                  }
                  return {
                    ...option,
                    label: option.value
                  }
                }),
                value: [...(input.value || [])].filter((v) => !v.zoneId)
              }
            }

            if (input.type === 'zone') {
              const work = this.options_works.find(({id}) => id === job.work_type)

              if (work && work.dir) {
                const dir = this.dirs.find(({id}) => id === work.dir);

                if (dir && dir.defaultZone && !input.value) {
                  setTimeout(() => {
                    input.value = input.options.find((d) => dir.defaultZone === d.value);
                  }, 1000)
                }

                if (dir && dir.usePermission) {
                  try {
                    input.options = input.options.filter((d) => dir.available_objects.includes(d.value) || !d.value)
                  } catch (e) {

                  }
                }
              }
            }

            return input
          })


          // const inputsValues = {
          //   ...inputs,
          // }


          this.form.job = {
            ...this.form.job,
            inputs
          }
        }

        this.prevZone = {...nextZone};
      }
    },
  },
  methods: {
    toFixedWithoutZero,
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 85) {
        return '#F57C00'
      }

      return '#D32F2F'
    },
    findPercentage(a, b) {
      if (!a) {
        return 0
      }

      if (!b) {
        return 100
      }


      return Number((Number(a || 0) / Number(b)) * 100).toFixed(0);
    },
    toFactNomenclature(result) {
      this.form.value = result
      this.form = {...this.form}
    },
    searchWithoutDelay(search, input) {
      if (!input.type.includes('L')) {
        return
      }
      const index = this.form.job.inputs.findIndex(({id}) => id === input.id)
      this.form.job.inputs[index].isLoading = true
      this.form.job = {
        ...this.form.job,
      }
      this.searchL(search, input)
    },
    searchL: debounce(async function (search, input) {
      const index = this.form.job.inputs.findIndex(({id}) => id === input.id)
      this.form.job.inputs[index].isLoading = true
      this.form.job = {
        ...this.form.job,
      }

      const zone = this.form.job.inputs.find(({id}) => id === 'zone')
      if (!input.type.includes('L')) {
        return
      }
      input.isLoading = true


      let resp = null


      if (search && search.length) {
        const cyrillicToTranslit = new CyrillicToTranslit();


        const txt = String(cyrillicToTranslit.transform(search).toLowerCase())
        const txtArray = txt.split(' ')
        const query = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(input.id)
          .collection('optionsList')
          // .where('searchName', '<=', txt + '\uf8ff')
          .where('searchName', 'array-contains', txtArray[txtArray.length - 1])

        if (zone && zone.value && zone.value.value) {
          query.where('zoneId', '==', zone.value.value)
        }

        resp = await query.limit(100).get()
      } else {
        if (zone && zone.value && zone.value.value) {
          resp = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .orderBy('index', 'asc')
            .where('zoneId', '==', zone.value.value).limit(100).get()
        } else {
          resp = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .orderBy('index', 'asc')
            .limit(100).get()
        }
      }

      const result = []
      resp.forEach((d) => {
        result.push(
          {
            id: d.id,
            ...d.data(),
          }
        )
      })

      this.form.job.inputs[index].options = [...orderBy(result, 'index', 'asc')]

      this.form.job.inputs[index].isLoading = false
      this.form.job = {
        ...this.form.job,
      }
    }, 500),
    saveNomennclature(d, input) {
      const index = this.form.job.inputs.findIndex(({id}) => input.id === id)
      this.form.job.inputs[index].selectValues = d
      if (!this.form.job.inputs[index].selectValues || !Object.keys(this.form.job.inputs[index].selectValues).length) {
        this.form.job.inputs[index].selectValues = null
      }

      this.form.job = {...this.form.job}
    },
    doCopy() {
      this.form.reportId = null
      this.copyJobOpen = false
      this.editIndex = null
      this.save(true)
    },
    saveCopy(e) {
      this.$emit('save', {
        ...e,
        structureObj: this.structureObj,
        isEdit: this.isEdit,
        editId: null
      })
      this.dialogObject = false
      this.clear()
    },
    async updateReport() {
      const result = await this.fetchParent();
      const {data, id} = result;

      data.inputObjects.forEach((obj, index) => {
        obj.jobs.forEach((job, i) => {
          if (data.inputObjects[index].jobs[i].reportId === this.form.reportId) {
            data.inputObjects[index].jobs[i] = {
              ...data.inputObjects[index].jobs[i],
              ...this.form,
            }
          }
        })
      })

      await this.updateJobSave(this.form.reportId)
      await this.updateReportSave(id, data)

      this.$notify.success({
        title: 'Успешно!',
        offset: 60,
        message: 'Работа успешно обновлена',
      });

      this.dialogObject = false;
      this.clear()
    },
    async removeReportClick() {
      if (this.editIndex === 'create') {
        return this.removeReport()
      }


      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.form.id)
        .delete();

      if (this.form.reportPROF) {
        await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.form.reportPROF)
          .delete();
      }

      this.$emit('remove', {
        form: {...this.form, approve: false},
        structureObj: this.structureObj,
        isEdit: this.isEdit,
        editId: this.editIndex,
        fact: this.planFactTech.fact || null,
      })

      this.dialogObject = false;
      this.clear()
    },
    async removeReport() {
      const result = await this.fetchParent();
      const {data, id} = result;

      data.inputObjects.forEach((obj, index) => {
        obj.jobs.forEach((job, i) => {
          if (data.inputObjects[index].jobs[i].reportId === this.form.reportId) {
            data.inputObjects[index].jobs.splice(i, 1)
          }
        })
      })


      await this.updateReportSave(id, data)

      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports').doc(this.form.reportId).delete()


      this.$notify.success({
        title: 'Успешно!',
        offset: 60,
        message: 'Работа успешно удалена',
      });
      this.dialogObject = false;
      this.clear()
    },
    async updateReportSave(id, data) {
      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('workorders').doc(id).update(JSON.parse(JSON.stringify({...data})))
    },
    async updateJobSave(id) {
      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(id)
        .update(JSON.parse(JSON.stringify({
          "TECH": {
            "workers": 0,
            "itr": 0,
            "workers_plan": 0,
            "itr_plan": 0,
            "index": null,
            ...this.form.TECH
          },
          "PROF": {
            "workers": 0,
            "itr": 0,
            "workers_plan": 0,
            "itr_plan": 0,
            "index": null,
            ...this.form.PROF
          },
          // comment: this.form.comment,
          datetime: dayjs(this.form.datetime).format(),
          dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          "jobs": [
            {job: {...this.form.job, isCreate: true, value: toFloat(this.form.value)}}
          ],
          "files": this.form.files,
          executor: this.form.user,
          "turn": this.form.turn,
          isWorkOrder: true,
          "user": this.form.user,
        })))
    },
    async fetchParent() {
      let query = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('workorders').where('index', '==', this.form.workOrderIndex).get()

      let data = {}

      query.forEach((d) => {
        data = {
          id: d.id,
          data: d.data()
        }
      })

      return data;
    },
    selectJobInsert(job) {
      if (job.user && job.executor) {
        job.user = {
          ...job.executor,
          label: job.executor.name,
          value: job.executor.uid,

        }
      }
      this.openJob(job)

      this.openUid = true
      this.dialogObjectSearch = false
    },
    getCurrentObj() {
      try {
        const obj = this.mainForm.inputObjects.find(({id}) => id === this.structureObj);
        return obj.jobs[this.editIndex]
      } catch (e) {
        return null
      }
    },
    async save(isCopy = false) {

      this.form.value = toFloat(this.form.value);

      this.loader = true;
      if (this.editIndex === 'create') {
        return this.updateReport()
      }

      let index = await fetchIndex(this.$store.state.project.id)

      const obj = this.mainForm.inputObjects.find(({id}) => id === this.structureObj);

      const PROF_AND_TECH = {
        PROF: {
          index: index + 1,
          itr: 0,
          itr_plan: 0,
          workers: this.form.PROF.value,
          workers_plan: 0,
          total: this.form.PROF.total,
          value: this.form.PROF.value,
          time: this.form.PROF.time,
        },
        TECH: {
          index: 0,
          itr: 0,
          itr_plan: 0,
          workers: 0,
          workers_plan: 0,
        }
      }

      const linkedUid = uuidv4();

      const dataJob = JSON.parse(JSON.stringify({
        ...getJobStructure({
          form: this.mainForm,
          store: this.$store,
          index: this.form.index || index,
          job: {...this.form, uid: (this.form.jobs && this.form.jobs[0] && this.form.jobs[0].uid) || linkedUid},
          obj,
          user: this.form.user && this.form.user._data,
          reporter: this.user
        }),
        workOrderId: this.$route.params.id,
        wordOrderObject: this.structureObj,
        workOrderJob: {
          id: this.form.uid,
          name: obj.jobs[this.editIndex].name,
        },
        userId: firebase.auth().currentUser.uid
      }))

      let dataProf = null

      if (this.form.PROF.jobs) {
        dataProf = JSON.parse(JSON.stringify({
          ...getJobStructurePROF({
            form: this.mainForm,
            store: this.$store,
            index: this.editProf.index || index + 1,
            job: this.form,
            obj,
            user: this.form.user && this.form.user._data,
            reporter: this.user
          }, [...(this.form.PROF.jobs || [])].map((job) => {

            return {
              originalJob: job,
              is_daily: false,
              is_select: null,
              plan: job.plan,
              time: job.time,
              value: job.value || job.fact,
              total: job.total,
              uid: job.uid || uuidv4(),
              linkedUid: job.linkedUid || linkedUid,
              job: {
                uid: job.uid || uuidv4(),
                linkedUid: job.uid || linkedUid,
                ...job,
                work_type: job.work_type || this.form.work_type,
                work_type_name: job.work_type_name || this.form.work_type_name,
              },
            }
          })),
          ...PROF_AND_TECH,
          userId: firebase.auth().currentUser.uid
        }));
      }

      const prof_work_type = []
      const prof_work_type_ids = []


      if(dataProf && dataProf.jobs) {
        dataProf.jobs[0] = dataProf.jobs[0].map((job) => {
          if (!job.job.work_type) {
            let work_type = this.form.work_type;
            let work_type_name = this.form.work_type_name;

            if (work_type && work_type.value) {
              work_type = this.form.work_type.value;
              work_type_name = this.form.work_type.label
            }

            job.job.work_type = work_type
            job.job.work_type_name = work_type_name

            const workType = this.workTypeOptions.find(({value}) => work_type === value) || {data: {}}

            prof_work_type.push({
              label: work_type_name,
              id: work_type,
              dir: workType.data.dir || null,
              value: workType.data.unit || this.form.unit,
            })

            if(work_type && !Array.isArray(work_type)) {
              prof_work_type_ids.push(work_type)
            }
          }
          return job
        })


        delete dataProf.work_type;
        delete dataProf.work_type_ids;

        dataProf.work_type = prof_work_type
        dataProf.work_type_ids = prof_work_type_ids
      }

      console.log(dataProf, 'dataProf')


      if (!this.form.id) {

        let prof = {}
        if (dataProf) {
          prof = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('reports')
            .add(JSON.parse(JSON.stringify({
              ...dataProf,
              datetime: dayjs(this.form.datetime).format(),
              dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              userId: firebase.auth().currentUser.uid,
            })));

          this.form.reportPROF = prof.id

          this.reportPROFIndex = prof.index;
          this.reportPROF = prof.id
          dataJob.reportPROF = prof.id
        }


        const data = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .add(JSON.parse(JSON.stringify({
            ...dataJob,
            reportPROF: prof.id || null,
            datetime: dayjs(this.form.datetime).format(),
            dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            ...PROF_AND_TECH
          })));


        if (dataProf) {
          await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('reports')
            .doc(prof.id)
            .update({
              from: data.id
            });

        }

        this.loader = false;

        this.$emit('save', {
          form: {...dataJob, id: data.id},
          structureObj: this.structureObj,
          isEdit: this.isEdit,
          editId: this.editIndex,
          fact: this.planFactTech.fact || null,
          isCopy: isCopy,
          reportIndex: index,
          reportId: data.id
        })
      } else {

        let newProf = {}


        if (this.form.reportPROF || this.reportPROF) {
          try {
            this.reportPROF = this.form.reportPROF;
            await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('reports')
              .doc(this.form.reportPROF || this.reportPROF)
              .update(JSON.parse(JSON.stringify({
                jobs: dataProf.jobs,
                datetime: dayjs(this.form.datetime).format(),
                dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              })));
          } catch (e) {}

        } else if (!this.form.reportPROF && !this.reportPROF && dataProf) {

          newProf = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('reports')
            .add(JSON.parse(JSON.stringify({
              ...dataProf,
              from: this.form.id,
              datetime: dayjs(this.form.datetime).format(),
              dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              userId: firebase.auth().currentUser.uid,
              ...PROF_AND_TECH
            })));

          if (newProf && newProf.id) {
            dataJob.reportPROF = newProf.id
            this.form.reportPROF = newProf.id;
            this.reportPROF = newProf.id;

            this.reportPROFIndex = dataProf.index;
          }
        }

        delete dataJob.reportPROF

        if (this.form.reportPROF || this.reportPROF) {
          dataJob.reportPROF = this.form.reportPROF || this.reportPROF
        }

        if(!this.form.PROF) {
          this.form.PROF = {}
        }

        await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.form.id)
          .update(JSON.parse(JSON.stringify({
            ...dataJob,
            PROF: {
              ...this.form.PROF,
              index: this.reportPROFIndex || (dataProf && dataProf.index) || null,
              workers: this.form.PROF.value,
              workers_plan: 0,
              total: this.form.PROF.total,
              value: this.form.PROF.value,
              time: this.form.PROF.time,
            },
            datetime: dayjs(this.form.datetime).format(),
            dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          })));


        this.loader = false;
        this.$emit('save', {
          form: {...dataJob, id: this.form.id},
          structureObj: this.structureObj,
          isEdit: this.isEdit,
          editId: this.editIndex,
          fact: this.planFactTech.fact || null,
          isCopy: isCopy,
          reportIndex: index,
          reportId: this.form.id
        })
      }
      this.clear()
      this.dialogObject = false
    },
    saveProf(prof) {
      this.form.PROF = prof;

      this.form = {...this.form}
    },
    saveTech(tech) {
      this.form.TECH = tech;
      this.form = {...this.form}

    },
    async selectJob(job = {}) {
      if (!job) {
        job = {}
      }

      this.form.job = {
        ...(this.form.job || {}),
        fact: 0,
        inputs: job.inputs || [],
        ...job,
        reports: job.reports,
      }


      this.savedJob = {
        ...this.savedJob,
        inputs: job.inputs ||  []
      }


      if (this.form.job) {
        let dir = {dir: null};
        let zones = []
        let result = []

        if (this.form.job && this.form.job.work_type) {
          dir = (await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('works_type')
            .doc(this.form.job.work_type.value || this.form.job.work_type).get()).data()
        }


        const zoneDirs = this.$store.state.project.zoneDirs || []

        if (zoneDirs.includes((dir.dir || 'all'))) {
          zones = await getZonesOptions(this.$store.state.project.id)

          if (this.savedJob && this.savedJob.inputs) {
            const v = this.savedJob.inputs.find(({id}) => id === 'zone')

            if (v) {
              result.push({
                options: zones,
                name: 'Зона работы',
                index: 0,
                type: 'zone',
                value: v.value,
                id: 'zone'
              })
            } else {
              result.push({
                options: zones,
                name: 'Зона работы',
                index: 0,
                type: 'zone',
                value: null,
                id: 'zone'
              })
            }
          }
          result = [...result]
        }

        const inputs = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .where(`dirs`, 'array-contains-any', [dir.dir || 'all'])
          .get()



        inputs.forEach((input) => {
          const data = input.data();
          if (!data.type) {
            data.type = {
              label: 'Текст',
              value: 'text',
            }
          }
          delete data.checked;
          const dataResult = {
            ...data,
            options: data.options,
            type: data.type.value || data.type,
            value: null,
            id: input.id
          }

          if (this.savedJob && this.savedJob.inputs) {
            const v = this.savedJob.inputs.find(({id}) => id === input.id)
            if (v) {
              dataResult.value = v.value
              dataResult.selectValues = v.selectValues || null
            }
          }

          result.push({...dataResult})
        })

        if (result) {
          this.form.job.inputs = _.orderBy(result, 'index', ['asc'])
        } else {
        }
        this.form.job = {...this.form.job, reports: job.reports}
        this.form = {...this.form}
      }
    },
    async openJob(job) {
      this.dialogObject = true
      this.selectJob(job.jobs[0].job || {})

      this.originalId = job.originalId

      this.form = {
        ...this.form,
        value: job.jobs[0].job.value,
        ...job,
        plan: job.plan,
        PROF: job.PROF || {},
        TECH: job.TECH || {}
      }

      if (this.form.reportPROF) {
        const prof = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports').doc(this.form.reportPROF).get()

        const report = prof.data()
        if (report) {
          this.form.PROF = {...report.PROF, ...this.form.PROF}
          this.form.PROF.jobs = (report.jobs && report.jobs[0]) || [];
          this.editProf = report
        }
      }

      if (job.jobs && job.jobs[0]) {
        this.form.job.comment = job.jobs[0].comment
      }


      console.log(this.form, 'this FORM')

    },
    async open(job = {}, index, id, calcValue) {
      this.calcValue = calcValue;

      this.dialogObject = true
      this.selectJob({...job.job, reports: job.reports} || {})
      this.editIndex = index;

      this.reports = job.reports || []
      this.structureObj = id
      this.originalId = job.originalId


      this.form = {
        ...this.form,
        ...job,
        plan: job.plan,
        PROF: job.PROF || {},
        TECH: job.TECH || {}
      }

      this.form.job.unit = job.unit;
      this.calcPlan = this.form.plan
      this.currentIndexReport = await fetchIndex(this.$store.state.project.id)
      this.form.index =   this.currentIndexReport;
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    addFile(f) {
      this.form.files.push(f);
    },
    openAddProf() {
      this.form.uid = this.form.uid || uuidv4()
      this.$emit('add-prof', {
        uid: this.form.uid,
        job: this.form.job
      })
    },
    inputMaterial(e, input) {
      if (input.type !== 'multiple' || input.isDetail) {
        this.openDialogMaterials = true
      }
      this.selectMaterial = {
        ...e,
        fact: '',
        factUnit: '',
        detail: '',
        withoutPlan: input.withoutPlan,
        isDetail: input.isDetail,
        inVolume: input.type === 'constructions',
        parentId: input.id,
        type: input.type
      };
    },
    removeMaterial(e, input) {
      const index = input.options.findIndex(({uid, value, label}) => uid === e.uid && value.trim() === e.value.trim())

      if (index !== -1 && input.options.filter((o) => o.uid === e.uid).length > 1) {
        input.options.splice(index, 1)
      }
      this.form = {...this.form}
    },
    filterMaterials(input) {
      try {
        if (!input.isZone) {
          return [...(input.options || [])].filter((option) => !option.zoneId)
        }

        const zone = this.form.job.inputs.find(({id}) => id === 'zone').value || {value: 'all'}
        return [...(input.options || [])].filter((option) => !option.zoneId || option.zoneId === zone.value);
      } catch (e) {
        return []
      }
    },
    sortOptions(options, value) {
      if (Array.isArray(value)) {
        const values = value || [];

        const optionsWithoutValues = options.filter((o) => !(values || []).find((v) => v.uid === o.uid && v.value === o.value));

        return [..._.orderBy(values, ['label'], ['desc']), ...optionsWithoutValues] //_.orderBy(options, ['label'], ['desc'])
      } else {
        return options
      }
    },
    toFact(input) {
      let result = 0

      input.value.forEach((value) => {
        if (value.inVolume) {
          result = new BigNumber(result)
            .plus(input.type === 'constructions' ? value.factUnit : value.fact).toNumber()
        }
      })

      this.form.value = result
      this.form = {...this.form}
    },
    saveMaterial(flag) {
      /// НЕ ТРОГАТЬ
      const index = this.form.job.inputs.findIndex(({id}) => this.selectMaterial.parentId === id)

      const option = this.form.job.inputs[index].options.find(({value}) => value === this.selectMaterial.value);
      if (!option) {
        this.form.job.inputs[index].options.push({
          details: this.selectMaterial.details,
          id: this.selectMaterial.id,
          index: this.selectMaterial.index,
          isCreate: this.selectMaterial.isCreate,
          label: this.selectMaterial.label,
          uid: this.selectMaterial.uid,
          value: this.selectMaterial.value,
          zoneId: this.selectMaterial.zoneId
        })

      }
      // options.find(({value}) => )
      const childIndex = this.form.job.inputs[index].options.findLastIndex(
        ({
           uid,
           value,
           label
         }) => uid === this.selectMaterial.uid
          && this.selectMaterial.value.trim() === value.trim()
          && this.selectMaterial.label.trim() === label.trim()
      );

      if (this.selectMaterial.isDetail && this.form.job.inputs[index].options[childIndex]) {
        const input = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex]))
        const option = {
          ...JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex])),
          value: JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex])).value,
          label: input.originalLabel || input.label,
        }

        this.form.job.inputs[index].options.push({...option})
      }


      if ((this.selectMaterial.type.includes('multiple') || flag) && this.form.job.inputs[index].options[childIndex]) {
        this.form.job.inputs[index].options[childIndex].label = '' + this.selectMaterial.value + (this.selectMaterial.fact ? ' - ' + this.selectMaterial.fact : '') + ' ' + ((this.selectMaterial.details[1] && this.selectMaterial.details[1].label) || '')
      }


      // if(this.selectMaterial.type === 'materials') {
      this.form.job.inputs[index].options[childIndex].originalLabel = '' + this.form.job.inputs[index].options[childIndex].value
      // }

      if (this.selectMaterial.type.includes('multiple')) {
        try {

          const trueKeys = Object.keys(this.form.job.inputs[index].volumeId).filter(key => this.form.job.inputs[index].volumeId[key] === true);

          const details = this.form.job.inputs[index].options[childIndex].details
          if (trueKeys && trueKeys.length) {
            let sumKey = 0;
            let label = ''

            trueKeys.forEach((key) => {
              if (details[key] && !isNaN(details[key])) {
                sumKey += Number(details[key])
                label = this.form.job.inputs[index].labels[key]
              }
            })


            this.form.job.inputs[index].options[childIndex].originalLabel = '' + this.form.job.inputs[index].options[childIndex].value

            this.form.job.inputs[index].options[childIndex].label = '' + this.selectMaterial.value + ' - (' + sumKey + ' ' + label + ')'
          } else if (!flag) {
            return;
          }
        } catch (e) {
          console.error(e)
          if (!flag) {
            return
          }
        }
      }


      this.form.job.inputs[index].options[childIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].options[childIndex].fact = this.selectMaterial.fact;
      this.form.job.inputs[index].options[childIndex].inVolume = this.selectMaterial.inVolume;


      const valueIndex = this.form.job.inputs[index].value.findLastIndex(({uid}) => uid === this.selectMaterial.uid);

      this.form.job.inputs[index].value[valueIndex].label = this.form.job.inputs[index].options[childIndex].label
      this.form.job.inputs[index].value[valueIndex].fact = this.selectMaterial.fact;
      if (this.selectMaterial.isDetail) {
        this.form.job.inputs[index].value[valueIndex].detail = this.selectMaterial.detail
      }


      if (this.selectMaterial.inVolume && !this.selectMaterial.withoutPlan) {
        this.form.job.inputs[index].options[childIndex].label = '• ' + this.form.job.inputs[index].options[childIndex].label;
        this.form.job.inputs[index].value[valueIndex].inVolume = true
      }

      if (this.form.job.inputs[index].type.includes('constructions')) {
        this.form.job.inputs[index].value[valueIndex].factUnit = this.selectMaterial.factUnit;
        this.form.job.inputs[index].options[childIndex].label += isNaN(this.selectMaterial.factUnit) ? '' :
          (this.selectMaterial.details[3] || this.selectMaterial.factUnit ? ` (${this.selectMaterial.factUnit} ${(this.selectMaterial.details[3] && this.selectMaterial.details[3].label)})` : '')
      }

      if (this.selectMaterial.isDetail && this.selectMaterial.detail) {
        this.form.job.inputs[index].options[childIndex].label += ' (' + this.selectMaterial.detail + ')'
      }


      this.form.job.inputs[index].value[valueIndex].label = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].value[valueIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].options[childIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))

      this.form = {...this.form}
      this.openDialogMaterials = false;
      this.selectMaterial = {}

    },
    closeMaterial() {
      this.openDialogMaterials = false;
      const index = this.form.job.inputs.findIndex(({id}) => this.selectMaterial.parentId === id)

      this.form.job.inputs[index].value = this.form.job.inputs[index].value.filter(({
                                                                                      uid,
                                                                                      value
                                                                                    }) => uid !== this.selectMaterial.uid || value !== this.selectMaterial.value)
      this.form.job.inputs = [...this.form.job.inputs]
      setTimeout(() => {
        this.selectMaterial = {}
      }, 200)
    },
    addNew(data, name) {
      this.input = data;
      let zone = null
      try {
        zone = this.form.job.inputs.find(({id}) => id === 'zone').value || null
      } catch (e) {
      }

      this.$refs.addNewOption.open({
        zone,
        data, name
      })
    },
    toFactMultiple(input) {
      let id = Object.values(input.volumeId).findIndex((o) => o)
      let result = 0
      input.value.forEach(({details}) => {
        result += Number(details[id + 1])
      })

      this.form.value = result
      this.form = {...this.form}
    },
    openAddTech() {
      this.form.uid = this.form.uid || uuidv4()
      this.$emit('add-tech', {
        uid: this.form.uid,
        job: this.form.job
      })
    },
    showCalc(obj) {
      try {
        return !!Object.values(obj).find((o) => o)
      } catch (e) {
        return false
      }
    },
    getCalc(input) {
      let n1 = 0
      let n2 = 0

      const findValue = (value) => {
        const res = this.form.job.inputs.find(({id}) => id === value)
        return (res && res.value) || 0
      }

      if (input.options[0].value === 'fact') {
        n1 = this.form.value
      } else {
        n1 = findValue(input.options[0].value)
      }

      if (input.options[1].value === 'fact') {
        n2 = this.form.value
      } else {
        n2 = findValue(input.options[1].value)
      }

      const operators = {
        '+': function (x, y) {
          return Number(x) + Number(y);
        },
        '-': function (x, y) {
          return Number(x) - Number(y);
        },
        '*': function (x, y) {
          return Number(x) * Number(y);
        },
        '/': function (x, y) {
          return Number(x) / Number(y);
        }
      };

      const result = operators[input.operation.value](n1, n2)
      input.value = result

      return result
    },
    clear() {
      this.loader = false;

      this.dialogObject = false
      this.reportPROF = null
      this.form = {
        value: '',
        time: '',
        job: {},
        work_type: {},
        TECH: {},
        files: [],
        PROF: {},
        turn: {
          label: 1,
          value: 1
        },
        daily_plan: '',
        datetime: dayjs().format(),
        comment: '',
      }
      this.savedJob = {}
      this.step = 0;
      this.openUid = false
      this.isCreateCustom = false;
    },
    inputMat(selectMaterial) {
      if (selectMaterial.withoutPlan) {
        return
      }
      selectMaterial.factUnit = new BigNumber(selectMaterial.fact || 0).multipliedBy(selectMaterial.details[4] || 0).toNumber()
    },
    inputOption(input, opt) {

      if (input.type === 'multiple' && input.volumeId && opt) {
        const indexInput = this.form.job.inputs.findIndex(({id}) => input.id === id)

        const index = Object.values(input.volumeId).findIndex((d) => d)
        this.form.job.inputs[indexInput].options = this.form.job.inputs[indexInput].options.map((option) => {
          return {
            ...option,
            label: option.value
          }
        })


        if (input.isDetail) {
          this.openDialogMaterials = true


          this.selectMaterial = {
            ...opt[opt.length - 1],
            fact: '',
            factUnit: '',
            detail: '',
            isDetail: input.isDetail,
            parentId: input.id,
            details: [],
            type: input.type
          };
        }


        opt.forEach((o) => {
          const childIndex = this.form.job.inputs[indexInput].options.findIndex(({uid}) => uid === o.uid);
          const valueIndex = this.form.job.inputs[indexInput].value.findIndex(({uid}) => uid === o.uid);

          this.form.job.inputs[indexInput].options[childIndex].label = o.value + ` ${o.details[index + 1] ? '(' + o.details[index + 1] + ' ' + input.labels[index + 1] + ')' : ''}`;
          this.form.job.inputs[indexInput].value[valueIndex].label = this.form.job.inputs[indexInput].options[childIndex].label
        })
      }

      if (input.type === 'zone') {
        this.zoneLock = false
      }
      this.form = {
        ...this.form
      }
    },
    addNewInput(data, id, value) {
      const index = this.form.job.inputs.findIndex((job) => job.id === id)

      this.form.job.inputs[index] = {
        ...data,
        value: data.type === 'select' ? value : [...(this.form.job.inputs[index].value || []), value],
        id: id
      }

      this.inputOption(this.form.job.inputs[index], this.form.job.inputs[index].value)

      this.form = {
        ...this.form
      }

      if (data.type === 'materials' || data.type === 'constructions') {
        this.openDialogMaterials = true
        const options = this.form.job.inputs[index].options;
        this.selectMaterial = {
          ...this.form.job.inputs[index].options[options.length - 1],
          fact: '',
          factUnit: '',
          inVolume: data.type === 'constructions',
          parentId: id,
          type: data.type
        };
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}

.add-jobs {
  display: flex;
  flex-direction: column;


  .el-form-item {
    margin-bottom: 0px !important;
  }

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    width: 100%;
    justify-content: flex-start;
    min-height: 36px;
    padding: 8px 10px;
    display: flex;
    text-align: left;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.jobs-create-container {
  margin-top: -46px !important;
}

.sum-icon {
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #fff;
  background: black;
  cursor: pointer;
  border-radius: 50%;
}

.disable-report {
  opacity: 0.6;
  pointer-events: none;
}

.add-jobs-values {
  display: flex;
}

.material-title {
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.head-date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

@media screen and (max-width: 764px) {
  .history {
    flex-direction: column !important;
  }
}

.history {
  display: flex;
  align-items: center;

  span {
    font-size: 10px;
  }

  strong {
    color: #000;
    font-size: 18px;
  }

  .report-number {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 16px;
    }
  }

  i {
    font-size: 26px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.disable-report {
  opacity: 0.6;
  pointer-events: none;
}


.el-icon-document-copy {
  font-size: 20px;
  cursor: pointer;
}

.fact-prof-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 4px;
  cursor: pointer;
  color: #000;

  i {
    margin-left: 6px;
  }
}

.el-icon-success {
  color: #2ecc71;
  font-size: 20px;
}

.report-file {
  display: flex;
  margin-top: 8px;
  justify-content: flex-end;
}
</style>

<style lang="scss">
.add-jobs-dialog-workorder {
  .el-dialog__body {
    padding-top: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/components/AddJobs.vue